import React from 'react';
import CclDataTable, { CclDataTableColumnDef, CclDataTableColumnType } from '../CclDataTable';
import Toaster from "../Toaster";
import ApiDefaultReportAirport from "../../code/api/ApiDefaultReportAirport";
import DefaultReportAirport from "../../code/models/DefaultReportAirport";
import ButtonConfirm, { ButtonConfirmSize } from "../ButtonConfirm";

import "../../css/admindefaulteditors.css";

export default function AdminDefaultReportAirport() {
    const [toastMessage, setToastMessage] = React.useState<string>("");
    const [DefaultReportAirportList, setDefaultReportAirportList] = React.useState<DefaultReportAirport[] | null>(null);
    const [selectedDefaultReportAirport, setSelectedDefaultReportAirport] = React.useState<DefaultReportAirport | null>(null);
    const [editDefaultReportAirport, setEditDefaultReportAirport] = React.useState<DefaultReportAirport | null>(null);
    const [anyChanges, setAnyChanges] = React.useState<boolean>(false);

    React.useEffect(() => {
        loadData();
    }, []);

    async function loadData() {
        ApiDefaultReportAirport.getDefaultReportAirports().then(data => {
            setDefaultReportAirportList(data);
        });
    }

    function reloadData() {
        setEditDefaultReportAirport(null);
        setSelectedDefaultReportAirport(null);
        setDefaultReportAirportList(null);
        loadData();
    }

    function saveChanges() {
        setToastMessage("");
        if (anyChanges && !!editDefaultReportAirport && !!selectedDefaultReportAirport) {
            let isNew = !selectedDefaultReportAirport.airportCode;
            ApiDefaultReportAirport.updateDefaultReportAirport(editDefaultReportAirport).then(updatedItem => {
                if (!!updatedItem) {
                    selectedDefaultReportAirport.airportCode = updatedItem.airportCode;
                    selectedDefaultReportAirport.reportAirportCode = updatedItem.reportAirportCode;

                    setToastMessage("Report Airport Saved.");

                    if (isNew) {
                        reloadData();
                    } else {
                        setEditDefaultReportAirport(null);
                        setSelectedDefaultReportAirport(null);
                        setAnyChanges(false);
                    }
                }
            });
        }
    }

    function cancelChanges() {
        setEditDefaultReportAirport(null);
        setSelectedDefaultReportAirport(null);
        setAnyChanges(false);
    }

    function addItem(): void {
        var newRow = new DefaultReportAirport();
        setSelectedDefaultReportAirport(newRow);
        setEditDefaultReportAirport(structuredClone(newRow));
        setAnyChanges(false);
    }

    function deleteItem(confirm: boolean) {
        if (!selectedDefaultReportAirport || !confirm) return;
        setToastMessage("");

        ApiDefaultReportAirport.deleteDefaultReportAirport(selectedDefaultReportAirport.airportCode, selectedDefaultReportAirport.reportAirportCode).then(success => {
            if (success) {
                setToastMessage(`Default Report Airport Deleted. (${selectedDefaultReportAirport.airportCode})`);
                reloadData();
            } else {
                setToastMessage("Unable to delete Default Report Airport.");
            }
        });
    }

    function checkHasChanges() {
        var isAnyChanges = editDefaultReportAirport !== null &&
            (selectedDefaultReportAirport?.airportCode !== editDefaultReportAirport?.airportCode ||
                selectedDefaultReportAirport?.reportAirportCode !== editDefaultReportAirport?.reportAirportCode);
        setAnyChanges(isAnyChanges);
    }

    function handleRowSelect(rowData: any) {
        setSelectedDefaultReportAirport(rowData);
        setEditDefaultReportAirport(structuredClone(rowData));
        setAnyChanges(false);
    }

    const profileColumnDefs: CclDataTableColumnDef[] = [
        {
            fieldName: "airportCode",
            title: "Airport",
            visible: true,
            type: CclDataTableColumnType.Data
        }, {
            fieldName: "reportAirportCode",
            title: "Report Airport",
            visible: true,
            type: CclDataTableColumnType.Data
        }
    ];

    function buildEditor() {
        return (<React.Fragment>
            {!!editDefaultReportAirport && !!selectedDefaultReportAirport &&
                <div key={"bp" + selectedDefaultReportAirport.airportCode}
                    className="row adm-default-editor">
                    <div className="col-1">
                        <label htmlFor="editAirport" className="form-label text-nowrap">Airport</label>
                        <input className="form-control" id="editAirport" defaultValue={selectedDefaultReportAirport.airportCode}
                            maxLength={3} autoComplete={"off"} disabled={!!selectedDefaultReportAirport.airportCode}
                            onChange={(e) => {
                                editDefaultReportAirport.airportCode = e.target.value;
                                checkHasChanges();
                            }}></input>
                    </div>
                    <div className="col-3">
                        <label htmlFor="editDescription" className="form-label text-nowrap">Description</label>
                        <input className="form-control" id="editDescription" defaultValue={selectedDefaultReportAirport.reportAirportCode}
                            maxLength={200} autoComplete={"off"} disabled={!!selectedDefaultReportAirport.airportCode}
                            onChange={(e) => {
                                editDefaultReportAirport.reportAirportCode = e.target.value;
                                checkHasChanges();
                            }}></input>
                    </div>
                    <div className="col adm-default-actionbuttons text-nowrap">
                        <button disabled={!anyChanges} className="btn btn-primary"
                            onClick={saveChanges}>Save Changes</button>
                        <button className="btn btn-outline-primary"
                            onClick={cancelChanges}>Cancel</button>
                        <ButtonConfirm enabled={!!selectedDefaultReportAirport.airportCode} buttonText={"Delete"}
                            confirmTitle={"Default Airport"}
                            confirmMessage={`Delete default report airport '${selectedDefaultReportAirport.airportCode} - ${selectedDefaultReportAirport.reportAirportCode}'?`}
                            buttonSize={ButtonConfirmSize.Normal}
                            cssClass={"btn btn-outline-danger"} onConfirm={deleteItem} />
                    </div>
                </div>}
        </React.Fragment>
        )
    }

    return (
        <React.Fragment>
            <div className="container-fluid adm-default-main">
                <div className='adm-default-buttonbar '>
                    <button disabled={!DefaultReportAirportList} className="btn btn-outline-primary" onClick={reloadData}>Reload</button>
                    <button disabled={!DefaultReportAirportList || (!!selectedDefaultReportAirport && !selectedDefaultReportAirport.airportCode)} className="btn btn-outline-primary"
                        onClick={addItem}>Add</button>                    
                </div>
                {buildEditor()}
                <div className='row adm-default-table-wrapper'>
                    <CclDataTable
                        name={"profilesTable"}
                        tableData={DefaultReportAirportList || []}
                        columnDefinitions={profileColumnDefs}
                        rowSelect={true}
                        onRowSelect={handleRowSelect}
                        onButtonClick={null} />
                </div>
            </div>
            <Toaster title="Default Airport" subtitle="" message={toastMessage} key={"defapttoast"} />
        </React.Fragment>
    )
}
